import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Listbox } from '@headlessui/react'
import { useCookies } from 'react-cookie'
import { useFirstRender } from '../hooks/useFirstRender'

export default function MarketSelect() {
  const data = useStaticQuery(graphql`
    query {
      wp {
        globalSettings {
          markets {
            markets {
              id
              name
              url
              code
            }
          }
        }
      }
    }
  `)

  const { markets } = data.wp.globalSettings.markets

  const [selectedMarket, setSelectedMarket] = useState(markets[0])

  const firstRender = useFirstRender()

  const [cookies, setCookie] = useCookies(['nf_country'])

  useEffect(() => {
    if (selectedMarket?.code) {
      setCookie('nf_country', selectedMarket.code, { path: '/', domain: '.colekt.com' })
    }

    if (!firstRender && typeof window !== 'undefined') {
      window.location.href = `https://${selectedMarket.url}`
    }
  }, [selectedMarket])

  return (
    <Listbox value={selectedMarket} onChange={setSelectedMarket}>
      <Listbox.Label className="font-extended text-base">Store: </Listbox.Label>
      <Listbox.Button className="font-extended text-base">{markets[0].name}</Listbox.Button>
      <Listbox.Options>
        {markets.map((market) => (
          <Listbox.Option key={market.id} value={market} className="font-extended text-base py-1 cursor-pointer">
            {market.name}
          </Listbox.Option>
        ))}
      </Listbox.Options>
    </Listbox>
  )
}
